import Axios from 'axios';


export const searchReconciliationApi = ({authToken, deviceId, userId, merchantId, page,  sort, search, startDate, endDate}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURLNew + 'merchant/reconcile/search',
            params: {
                userId : userId,
                merchantId : merchantId,
                merchantType : 2,
                sort : sort,
                page : page,
                nRecords : 20,
                startDate : startDate,
                endDate : endDate,
            },
            data: {},
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const searchReconciliationPayableApi = (data) => {
    if(data.authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURLNew + 'merchant/reconcile/search',
            params: {
                userId : data.userId,
                merchantId : data.merchantId,
                // merchantType : 0,
                merchantType : data.merchantType,
                sort : data.sort,
                page : data.page,
                nRecords : 10,
                startDate : data.startDate,
                endDate : data.endDate,
                trxType : data.trxType,
                pointTransactionTypeList : data.pointTransactionTypeList,
                merchantNamePayable : data.merchantNamePayable
                
            },
            data: {},
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'authToken': data.authToken,
                'deviceUniqueId' : data.deviceId
            }
        });
    };
};

export const searchReconciliationReceivebleApi = ({authToken, deviceId, userId, merchantId, page,  sort, search, startDate, endDate}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURLNew + 'merchant/reconcile/search',
            params: {
                userId : userId,
                merchantId : merchantId,
                merchantType : 1,
                sort : sort,
                page : page,
                nRecords : 20,
                startDate : startDate,
                endDate : endDate,
            },
            data: {},
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const searchReconciliationPointfeeApi = ({authToken, deviceId, userId, merchantId, page,  sort, search, startDate, endDate}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURLNew + 'merchant/reconcile/search',
            params: {
                userId : userId,
                merchantId : merchantId,
                merchantType : 2,
                sort : sort,
                page : page,
                nRecords : 20,
                startDate : startDate,
                endDate : endDate,
            },
            data: {},
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const viewReconciliationApi = ({authToken, deviceId, userId, merchantId, billingDetailId, productName, rewardName, merchantName, fee, basePrice, quantity, totalPrice, offset, pageSize, id}) => {
    if(authToken != null){
        return Axios({
            method: 'get',
            url: window.ApiURLNew + 'billing/detail',
            params: {
                userId : userId,
                merchantId : merchantId,
                billingId : id,
                billingDetailId : billingDetailId,
                productName : productName,
                rewardName : rewardName,
                merchantName : merchantName,
                fee : fee,
                basePrice : basePrice,
                quantity : quantity,
                totalPrice : totalPrice,
                offset : offset,
                pageSize : pageSize
            },
            data: {},
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'authToken': authToken,
                'deviceUniqueId' : deviceId
            }
        });
    };
};

export const getMerchantStatementsApi = ({ authToken, deviceId, startDate, endDate } = {}) => {
    const token = authToken || localStorage.getItem('a');
    const device = deviceId || localStorage.getItem('d') || 'Portal';
    const base = window.ApiURL || '';
    const url = base.endsWith('/') ? `${base}point/v2/merchant/statements` : `${base}/point/v2/merchant/statements`;

    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    return Axios({
        method: 'get',
        url: url,
        params: params,
        headers: {
            'authToken': token,
            'deviceUniqueId': device
        }
    });
};

export const getMerchantLedgerApi = ({
    authToken,
    deviceId,
    transactionCategory,
    startDate,
    endDate,
    page = 0,
    size = 10,
} = {}) => {
    const token = authToken || localStorage.getItem('a');
    const device = deviceId || localStorage.getItem('d') || 'Portal';
    const base = window.ApiURL || '';
    const url = base.endsWith('/') ? `${base}point/v2/merchant/ledger` : `${base}/point/v2/merchant/ledger`;

    const params = {
        page: page,
        size: size,
    };
    if (transactionCategory) {
        params.transactionCategory = transactionCategory;
    }
    if (startDate) {
        params.startDate = startDate;
    }
    if (endDate) {
        params.endDate = endDate;
    }

    return Axios({
        method: 'get',
        url: url,
        params: params,
        headers: {
            'authToken': token,
            'deviceUniqueId': device,
        },
    });
};
